import { type CSSProperties } from 'react';
import { css, styled } from 'styled-components';

import { isNumber } from '../../helpers/number';
import { Heading } from '../Heading';
import { Text } from '../Text';

type ContainerProps = {
  maxWidth: CSSProperties['maxWidth'];
};

const Container = styled.div<ContainerProps>`
  max-width: ${({ maxWidth }) => (isNumber(maxWidth) ? `${maxWidth}px` : maxWidth)};
`;

const textSubStyles = css`
  color: ${({ theme }) => theme.designTokens.cellTextSubSubColor};
  font-weight: ${({ theme }) => theme.designTokens.cellTextSubSubFontWeight};
  line-height: ${({ theme }) => theme.designTokens.heading5LineHeight};
`;

const SubHeading = styled(Heading)`
  ${textSubStyles};
  overflow: hidden;
`;

const SubText = styled(Text)`
  ${textSubStyles};
  overflow: hidden;
`;

export const Styled = {
  Container,
  SubHeading,
  SubText,
};
